<script>
    import MainHeader from "../AppHeader";
    import MainFooter from "../AppFooter";

    export default {
        name: 'Main',

        components: {
            MainHeader,
            MainFooter
        },


        computed: {
            defaultActive: function () {
                return this.$router.currentRoute.name;
            }
        }

    }
</script>


<template>
    <el-container id="viewport" direction="vertical">
        <main-header></main-header>
        <el-container>
            <el-aside width="250px">
                <h1 class="aside-header">Продукты</h1>
                <el-menu :router="true" :default-active="defaultActive">
                    <el-menu-item index="products" :route="{name:'products'}">
                        <el-icon class="el-icon-goods"></el-icon>
                        Продукты
                    </el-menu-item>
                    <el-menu-item index="products-properties" :route="{name:'products-properties'}">
                        <el-icon class="el-icon-tickets"></el-icon>
                        Характеристики
                    </el-menu-item>
                    <el-menu-item index="products-collections" :route="{name:'products-collections'}">
                        <el-icon class="el-icon-receiving"></el-icon>
                        Коллекции
                    </el-menu-item>

                </el-menu>
            </el-aside>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
        <main-footer></main-footer>
    </el-container>
</template>


<style scoped lang="scss">
    @import "../../scss/element";

    .el-aside {
        border-right: 1px solid #eeeeee;
        padding-top: 20px;
    }

    .el-menu {
        border-right: none;
        &-item {
            &.is-active {
                font-weight: 700;
                background-color: $--dropdown-menuItem-hover-fill;
            }
        }
    }
</style>